import {
  TEMPLATE_REGISTRY,
  type TemplateDefinition,
} from "@/components/AIComponents/ExportablesModal/templates/registry";
import type { GraphicOrganizersActivities } from "@/types/models";
import type {
  ExportablesDataTypes,
  ExportablesGenerationResponse,
} from "@/types/models/Exportables.interface";

const CROSSWORD_PUZZLE_IDENTIFIER = "crossword_puzzle";

const buildTemplateList = ({
  isStudent = false,
  isStudentPreviewOn = false,
  isSensitiveContent = false,
  fetchedGraphicOrganizerResponseData,
  exportablesMetadata,
}: {
  isStudent?: boolean;
  isStudentPreviewOn?: boolean;
  isSensitiveContent?: boolean;
  fetchedGraphicOrganizerResponseData?: GraphicOrganizersActivities | undefined;
  exportablesMetadata?: ExportablesGenerationResponse | undefined;
}): TemplateDefinition[] => {
  const allTemplates = Object.values(
    TEMPLATE_REGISTRY,
  ) as TemplateDefinition<ExportablesDataTypes>[];

  let templates: TemplateDefinition[] = [];

  if (isStudent || isStudentPreviewOn) {
    const fetchedIdentifiers =
      fetchedGraphicOrganizerResponseData?.graphic_organizers?.map((template) =>
        template.graphic_organizer_type.replace("graphic_organizer_", ""),
      ) || [];

    if (fetchedIdentifiers.length > 0) {
      templates = allTemplates.filter((template) =>
        fetchedIdentifiers.includes(template.seti_identifier),
      );
    }
  } else if (exportablesMetadata) {
    templates = allTemplates.filter(
      (template) => !!exportablesMetadata[template.seti_identifier],
    );
  }

  if (isSensitiveContent) {
    templates = templates.filter(
      (template) => template.seti_identifier !== CROSSWORD_PUZZLE_IDENTIFIER,
    );
  }

  return templates;
};

export default buildTemplateList;
